import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function Graph({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:1160px; margin:0 auto; display:flex; flex-direction:column; gap:26px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Graphe de liens</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>Ce qui se lit ensemble. Survolez un nœud pour isoler son voisinage.</p>
      </div>
      <div style={pstyle("display:grid; grid-template-columns:minmax(0,1fr) 300px; gap:40px; align-items:start;")}>
        <div style={pstyle("position:relative; height:520px; border:1px solid oklch(0.93 0.008 85); border-radius:10px; background:oklch(0.995 0.003 85); overflow:hidden;")}>
          {v.graphEdges}
          {v.graphNodes.map((n, i) => (
            <button
              type="button"
              key={i}
              onClick={n.onClick}
              onMouseEnter={n.onHover}
              style={pstyle("font:inherit; position:absolute; transform:translate(-50%,-50%); max-width:150px; border-radius:7px; padding:7px 11px; font-size:12.5px; line-height:1.35; text-align:center; cursor:pointer; z-index:2;", {
                left: n.left, top: n.top, border: "1px solid " + n.border, background: n.bg, color: n.color, opacity: n.opacity,
              })}
            >
              {n.label}
            </button>
          ))}
        </div>
        <div style={pstyle("display:flex; flex-direction:column; gap:14px;")}>
          <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>{v.graphFocusLabel}</div>
          <div style={pstyle("font-size:14px; line-height:1.7; color:oklch(0.4 0.015 60); text-wrap:pretty;")}>{v.graphFocusDesc}</div>
          <div style={pstyle("display:flex; flex-direction:column; gap:8px; border-top:1px solid oklch(0.95 0.006 85); padding-top:14px;")}>
            <span style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Voisins</span>
            {v.graphNeighbors.map((n, i) => (
              <Hoverable key={i} onClick={n.onClick} style={pstyle("display:flex; align-items:baseline; gap:10px; font-size:13.5px; color:oklch(0.4 0.015 60); cursor:pointer;")} hoverStyle={{ color: "oklch(0.46 0.075 55)" }}>
                <span>{n.label}</span>
                <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.56 0.015 60);")}>{n.kind}</span>
              </Hoverable>
            ))}
          </div>
          {v.graphHasArticle && (
            <button type="button" onClick={v.graphOpen} style={pstyle("background:none; border:none; padding:0; font:inherit; font-size:13.5px; color:oklch(0.46 0.075 55); cursor:pointer;")}>Ouvrir la fiche</button>
          )}
        </div>
      </div>
    </div>
  );
}
